<script lang="ts">
    import IconCollapseContent from './Icons/IconCollapseContent.svelte';
    import IconExpandContent from './Icons/IconExpandContent.svelte';
    export let checked: boolean = false;
    export let onClick: () => void = () => {};
</script>

<!--<IconListAlt scale={0.7} on:click={()=>{checked=!checked}}/>-->
{#if checked}
    <IconExpandContent
        scale={0.7}
        on:click={() => {
            checked = !checked;
            onClick();
        }}
    />
{:else}
    <IconCollapseContent
        scale={0.7}
        on:click={() => {
            checked = !checked;
            onClick();
        }}
    />
{/if}
